module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.599736fb.woff2";